import React from 'react';
import Text from '.';

const TitleLight = ({text, size, color, ownClass}) => {
    return(
        <Text
            ownClass={`title-light ${ownClass}`}
            text={text}
            size={size}
            color={color}/>
    )
}

export default TitleLight;